
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/contexts/LanguageContext";
import { motion } from "framer-motion";
import { Search } from "lucide-react";

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export const SearchBar = ({ searchQuery, onSearchChange }: SearchBarProps) => {
  const { t } = useLanguage();
  
  return (
    <motion.div 
      className="relative flex-1"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.1 }}
    >
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-primary/60">
        <Search className="h-4 w-4" />
      </div>
      <Input
        type="text"
        placeholder={t("searchInfluencers")}
        className="pl-9 bg-background border-primary/10 focus:border-primary/50 focus-visible:ring-primary/20 shadow-sm rounded-xl transition-all duration-300 hover:shadow-md"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </motion.div>
  );
};
